const trimTrailingSlash = (value) => String(value || '').trim().replace(/\/+$/, '');

export const API_URL = trimTrailingSlash(process.env.REACT_APP_API_URL) || '/api';
export const API_ORIGIN = API_URL.replace(/\/api$/, '');
export const FRONTEND_URL = trimTrailingSlash(process.env.REACT_APP_FRONTEND_URL) || (typeof window !== 'undefined' ? window.location.origin : '');

export function mediaUrl(path) {
  if (!path) return '';
  if (/^https?:\/\//i.test(path) || path.startsWith('/assets/')) return path;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_ORIGIN}${normalizedPath}`;
}
